import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * A coordinator's support requests as a phone reads them: one card each with
 * the course and section, the faculty member, the status, the facts that
 * decide which to open next, and one full-width action. It stands in for the
 * table below the md breakpoint, so nothing scrolls sideways or is cut off.
 *
 * `items` is `[{ key, heading, title, faculty, pill, facts, note,
 * actionLabel, to | onAction }]`; `facts` are short strings joined on one
 * line, `note` is anything the coordinator must notice before opening it.
 */
function RequestCardList({ items, label }) {
    if (items.length === 0) return null;
    return (
        <ul className="list-unstyled mb-0" aria-label={label}>
            {items.map((item) => {
                const name = `${item.actionLabel}: ${item.heading}`;
                return (
                    <li
                        key={item.key}
                        className="border-bottom px-3 py-3 request-card"
                    >
                        <div className="d-flex justify-content-between align-items-start gap-2">
                            <span className="fw-semibold">{item.heading}</span>
                            {item.pill}
                        </div>
                        {item.title && (
                            <div className="small text-body-secondary">
                                {item.title}
                            </div>
                        )}
                        <div className="mt-1">{item.faculty}</div>
                        {item.facts.length > 0 && (
                            <div className="small text-body-secondary">
                                {item.facts.join(' · ')}
                            </div>
                        )}
                        {item.note && <div className="mt-1">{item.note}</div>}
                        {item.to ? (
                            <Link
                                to={item.to}
                                className="btn btn-outline-primary w-100 mt-2 request-card-action"
                                aria-label={name}
                            >
                                {item.actionLabel}
                            </Link>
                        ) : (
                            <Button
                                variant="outline-primary"
                                className="w-100 mt-2 request-card-action"
                                aria-label={name}
                                onClick={item.onAction}
                            >
                                {item.actionLabel}
                            </Button>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}

export default RequestCardList;
